import Modal from 'src/components/ui/Modal';
import Pill from 'src/components/ui/Pill';
import { CLASSIC_ASSURANCE_COLORS, complianceBg, getTextColorForBg, type AssuranceLevel } from '../utils/color';
import { useChartTilesEnabled } from '../hooks/useDashboardTileStyle';

interface AssuranceLevelsInfoModalProps {
  open: boolean;
  onClose: () => void;
}

const LEVELS: { level: Exclude<AssuranceLevel, 'NaN'>; description: string }[] = [
  {
    level: 'High',
    description:
      'There was a strong system of internal control which has been effectively designed to meet the system objectives, and controls are consistently applied in all areas reviewed.'
  },
  {
    level: 'Substantial',
    description:
      'There was a good system of internal control designed to meet the system objectives, and controls were generally being applied consistently.'
  },
  {
    level: 'Moderate',
    description:
      'There was an adequate system of internal control, however, in some areas weaknesses in design and/or inconsistent application of controls puts the achievement of some aspects of the system objectives at risk.'
  },
  {
    level: 'Limited',
    description:
      'There was a compromised system of internal control as weaknesses in the design and/or inconsistent application of controls puts the achievement of the system objectives at risk.'
  },
  {
    level: 'None',
    description:
      'There was an inadequate system of internal control as weaknesses in control, and/or consistent non-compliance with controls could result in failure to achieve the system objectives.'
  }
];

export default function AssuranceLevelsInfoModal({ open, onClose }: AssuranceLevelsInfoModalProps) {
  const useChartTiles = useChartTilesEnabled();

  return (
    <Modal open={open} onClose={onClose} title="Assurance Levels Explained">
      <div className="space-y-4">
        <p className="text-sm text-gray-600">
          Assurance levels indicate the strength of internal controls and compliance with system objectives.
        </p>

        <div className="space-y-3">
          {LEVELS.map(({ level, description }) => (
            <div key={level} className="flex items-start gap-3">
              <Pill
                size="sm"
                className={`!text-xs mt-0.5 flex-shrink-0 min-w-[90px] justify-center ${useChartTiles ? complianceBg(level) : ''}`}
                style={
                  useChartTiles
                    ? undefined
                    : {
                        backgroundColor: CLASSIC_ASSURANCE_COLORS[level],
                        color: getTextColorForBg(CLASSIC_ASSURANCE_COLORS[level])
                      }
                }
              >
                {level}
              </Pill>
              <p className="text-sm text-gray-700">{description}</p>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
}
